import {combineReducers} from 'redux';
import TagSearchReducer from './tag_search_reducer/TagSearchReducer';

export default combineReducers({
  tagSearch: TagSearchReducer,
});
